import { useSearchParams } from 'react-router';

import { useIsClient } from '#/hooks/useIsClient';
import { useIsMobileSearchV2Enabled } from '#/layouts/Layout/Header/MobileSearchV2/useIsMobileSearchV2Enabled';
import { localStorageHasItem } from '#/utils/localStorage';

export const HAMBURGER_MENU_URL_PARAM = 'experiment_hamburger';
export const HAMBURGER_MENU_STORAGE_KEY = 'experimentHamburgerMenu';
export const HAMBURGER_MENU_URL_PARAM_OFF_VALUE = '0';

/**
 * Internal-only gate for the hamburger menu: Mobile Search V2 bucket plus
 * the `?experiment_hamburger` flag (persisted to localStorage by
 * EnableHamburgerMenuWithUrlParamGlobalHandler). Always false during SSR so
 * reading localStorage can't cause a hydration mismatch
 */
// TODO(@paprikka): temporary toggle, drop once sc-68335 is ready to be deployed
export function useIsHamburgerMenuEnabled(): boolean {
  const isMobileSearchV2Enabled = useIsMobileSearchV2Enabled();
  const isClient = useIsClient();
  const [searchParams] = useSearchParams();

  if (!isMobileSearchV2Enabled || !isClient) return false;

  // The URL covers the first load, before the handler has written the key
  const urlValue = searchParams.get(HAMBURGER_MENU_URL_PARAM);
  if (urlValue === HAMBURGER_MENU_URL_PARAM_OFF_VALUE) return false;
  if (urlValue !== null) return true;

  return localStorageHasItem(HAMBURGER_MENU_STORAGE_KEY);
}
